import { Key, PropsWithChildren } from 'react';

import {
  AnimatePresence,
  AnimatePresenceProps,
  MotionProps,
  motion,
} from 'motion/react';
import { Outlet } from 'react-router';

import { cn } from '../lib';

type IAnimatedWrapperProps = PropsWithChildren<{
  isFirst?: boolean;
  className?: string;
  type?: 'component' | 'route';
  id?: Key;
  duration?: number;
  mode?: AnimatePresenceProps['mode'];
}> &
  MotionProps;

export const AnimatedWrapper = ({
  type = 'component',
  isFirst,
  className,
  children,
  duration,
  mode = 'wait',
  id,
  ...props
}: IAnimatedWrapperProps) => {
  const toRender = (
    <>
      {type === 'route' && <Outlet />}
      {type === 'component' && children}
    </>
  );

  return (
    <AnimatePresence mode={mode}>
      {!isFirst ? (
        <motion.div
          className={cn(
            'absolute flex min-h-[100vh] w-full flex-col items-center overflow-hidden px-5 pt-[50px] lg:min-h-svh',
            className,
          )}
          key={id}
          initial={{ opacity: 0, left: 10 }}
          animate={{ opacity: 1, left: 0 }}
          exit={{ opacity: 0, left: -10 }}
          transition={{ duration: duration ?? 0.5 }}
        >
          {toRender}
        </motion.div>
      ) : (
        <motion.div
          className={className}
          key={id}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: duration ?? 0.5, ...props.transition }}
          {...props}
        >
          {toRender}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
